import { formatOneDigitNumber, weightAverageByMileage } from '@utils/formatters';

import createColumn from './createColumn';

export const speedSignal = {
    format: formatOneDigitNumber,
    average: weightAverageByMileage,
};

export const averageSpeed = createColumn({
    key: 'averageSpeed',
    dataField: 'averageSpeed',
    labelId: 'averageSpeed',
    formatter: speedSignal.format,
});
